import { useState, useEffect } from "react";
import MainScreen from "./components/MainScreen";
import ConsentScreen from "./components/ConsentScreen";
import { hasConsent } from "./utils/consent";
import "./App.css";

function App() {
  const [consentAccepted, setConsentAccepted] = useState(false);
  const [isChecking, setIsChecking] = useState(true);

  useEffect(() => {
    // Проверяем согласие при загрузке
    setConsentAccepted(hasConsent());
    setIsChecking(false);
  }, []);

  const handleAcceptConsent = () => {
    setConsentAccepted(true);
  };

  if (isChecking) {
    return (
      <div className="loading">
        <div className="spinner"></div>
      </div>
    );
  }

  if (!consentAccepted) {
    return <ConsentScreen onAccept={handleAcceptConsent} />;
  }

  return <MainScreen />;
}

export default App;
